/** Cycle 23 hotfix — API base resolution.
 *
 * HARD RULE: on any deployed (https) page, the API is SAME-ORIGIN — frontend and
 * backend are served from one domain and the ingress routes /api to the backend.
 * A build-time REACT_APP_BACKEND_URL must never send a page served from the
 * platform host off to the custom domain (or vice versa): that's cross-origin to a
 * host whose TLS may not even be provisioned yet (the production outage).
 *
 * The env override only applies to non-https local dev (e.g. http://localhost:3000),
 * where the page origin genuinely can't serve /api.
 */
export function resolveBackendUrl(origin, envUrl) {
  const org = (origin || "").replace(/\/+$/, "");
  if (/^https:\/\//.test(org)) return org; // deployed → same-origin, always
  const env = (envUrl || "").replace(/\/+$/, "");
  return env || org;
}
